import { render } from "./BaseOffer.vue?vue&type=template&id=3edc44ea"
import script from "./BaseOffer.vue?vue&type=script&lang=js"
export * from "./BaseOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__